import { NgModule } from '@angular/core'
import { SharedModule } from '../shared/shared.module'
import { HeaderComponent } from './header/header.component'
import { SidebarComponent } from './sidebar/sidebar.component'
import { MaterialModule } from '../shared/material/material.module'

@NgModule({
    imports: [SharedModule, MaterialModule, HeaderComponent, SidebarComponent],
    exports: [HeaderComponent, SidebarComponent],
})
export class LayoutModule {}
